import { render, staticRenderFns } from "./rewardSerialPackEdit_bak.vue?vue&type=template&id=16152d89&scoped=true&"
import script from "./rewardSerialPackEdit_bak.vue?vue&type=script&lang=js&"
export * from "./rewardSerialPackEdit_bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16152d89",
  null
  
)

export default component.exports